/* eslint-disable no-new */
import Vue from 'vue';

// Usage:
//
//   import { EventBus } from './eventBus';
//
//   # Sending Events
//   EventBus.$emit('eventName', someValue);
//
//   # Receiving Events
//   EventBus.$on('eventName', (value) => { ... });

const EventBus = new Vue();
export { EventBus as default };
